const handleClearCartItems = (profileId) => {
  localStorage.setItem(`@cart-${profileId}`, JSON.stringify({}));
};

const handleSetCartItems = (profileId, cart) => {
  localStorage.setItem(`@cart-${profileId}`, JSON.stringify(cart));
};

const getCartItems = (profileId) => {
  const data = JSON.parse(localStorage.getItem(`@cart-${profileId}`));
  return data ?? {};
};

const isCartHasItems = (profileId) => {
  const data = localStorage.getItem(`@cart-${profileId}`);
  return data && data !== '{}';
};

const handleSetSelectedStoreId = (profileId, storeId) => {
  localStorage.setItem(`@selectedStore-${profileId}`, JSON.stringify(storeId));
};

const handleClearSelectedStoreId = (profileId) => {
  localStorage.removeItem(`@selectedStore-${profileId}`);
};

const getSelectedStoreId = (profileId) => {
  const data = localStorage.getItem(`@selectedStore-${profileId}`);
  return JSON.parse(data);
};

const getProductLoadedStatus = () => {
  const data = localStorage.getItem('@product-loaded');
  return JSON.parse(data);
};

const handleSetProductLoaded = () => {
  localStorage.setItem('@product-loaded', JSON.stringify(true));
};

const handleClearProductLoaded = () => {
  localStorage.removeItem('@product-loaded');
};

export {
  handleClearCartItems,
  handleSetCartItems,
  getCartItems,
  isCartHasItems,
  handleSetSelectedStoreId,
  handleClearSelectedStoreId,
  getSelectedStoreId,
  getProductLoadedStatus,
  handleSetProductLoaded,
  handleClearProductLoaded,
};
